import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ChannelsService } from 'src/app/services/channels.service';
import { AccountService } from 'src/app/services/account.service';
import { AppComponent } from 'src/app/app.component';
import { ChannelResponse, HeroResponse } from '../../models';
import { Subject } from 'rxjs';
import { HeroService } from '../../services/hero.service';
import { LiveService } from '../../services/live.service';
import { takeUntil } from 'rxjs/operators';
import { copyObj } from 'src/app/services/helpers/helper-functions';
import { RecommendationsService } from '../../services/recommendations.service';

@Component({
    selector: 'app-channel-slider',
    templateUrl: './channel-slider.component.html',
    styleUrls: ['./channel-slider.component.scss']
})
export class ChannelSliderComponent implements OnInit, OnDestroy {


    channels: ChannelResponse[];
    @Input() type: string;
    @Input() header: string;

    hero: HeroResponse;
    destroy = new Subject<void>();
    @Input() heroResponse: HeroResponse;

    focusedRow =  0;

    constructor(
        private app: AppComponent,
        private authenticationService: AccountService,
        private channelsService: ChannelsService,
        private heroService: HeroService,
        private liveService: LiveService,
        private recommendationService: RecommendationsService) {
    }

    async ngOnInit() {
        if (this.type === 'standard') {
            this.focusedRow = -1

            let hero$ = this.heroService.getHeroV5Anon();
            if (this.isAuthenticated()) {
                hero$ = this.heroService.getHeroV5Auth();
            }

            hero$.subscribe(res => {
                res.heroes = res.heroes.filter(x => x.type !== 'internal-link-banner');
                this.heroResponse = res;
            });

            const [channels] = await Promise.all([
                this.channelsService.getChannels(false, !this.app.hasSubscription()).toPromise(),
                this.channelsService.refreshWatchHistory(),
            ]);

            this.channels = channels;

            if (this.isAuthenticated()) {


                const hotChannel = this.channels.find(x => x.type === 'hot-list');
                if (hotChannel) {
                    this.recommendationService.getPopular().subscribe({
                        next: rec => hotChannel.media = rec.media
                    });
                }

                const recommendedChannel = this.channels.find(x => x.type === 'user-recommendations');
                if (recommendedChannel) {
                    this.recommendationService.getRecommendedForYou().subscribe({
                        next: rec => recommendedChannel.media = rec.media
                    });
                }
            }

            this.liveService.status$.pipe(takeUntil(this.destroy)).subscribe(async status => {
                if (!status) {
                    return;
                }

                const index = this.channels.findIndex(x => x.slug === 'latest-uploads' || x.slug === 'latest-videos' || x.id === 23);
                const latestChannel = this.channels[index];

                if (!status.isLive) {
                    latestChannel.media = latestChannel.media.filter(x => x.livestreamId === undefined);
                    this.channels[index] = copyObj(latestChannel);
                    return;
                }

                const media = await this.liveService.getLiveMediaV2().toPromise();

                for (let i = 0; i < latestChannel.media.length; i++) {
                    if (latestChannel.media[i].livestreamId && !media.some(x => x.livestreamId === latestChannel.media[i].livestreamId)) {
                        this.channels[index].media.splice(i, 1);
                        this.channels[index] = copyObj(this.channels[index]);
                    }
                }

                for (let m of media) {
                    if (latestChannel.media.some(x => x.livestreamId === m.livestreamId)) {
                        continue;
                    }
                    latestChannel.media.unshift(m);
                    this.channels[index] = copyObj(latestChannel);
                }
            });
        } else if (this.type === 'shows') {
            this.channelsService.getChannelsShows()
                .subscribe({
                    next: res => {
                        this.channels = res;
                    },
                    error: error => {
                        this.authenticationService.checkUnauthorized(error);
                    }
                });
        }
    }

    ngOnDestroy() {
        this.destroy.next();
        this.destroy.complete();
    }

    isAuthenticated() {
        return this.app.isAuthenticated();
    }

    rowFocused(i: number) {
        this.focusedRow = i;
    }
}
